import { UserStatuses } from 'store/reducers/session/types';
import { GetUsersTableFiltersActionTypes, GetUsersTableFiltersState, SET_USERS_TABLE_FILTERS } from './types';

const defaultState: GetUsersTableFiltersState = {
  isLoading: false,
  errorMessage: '',
  contents: { status: UserStatuses.Active },
  exists: false,
};

export default function getUsersTableFilters(state = defaultState, action: GetUsersTableFiltersActionTypes): GetUsersTableFiltersState {
  switch (action.type) {
    case SET_USERS_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
